import type { ExcludedRowsConfig, RowConfig } from '@/shared/types/table';

function valuesMatch(cellValue: unknown, excluded: string | number): boolean {
  if (Object.is(cellValue, excluded)) return true;
  if (cellValue === null || cellValue === undefined) {
    return excluded === null || excluded === undefined;
  }
  return String(cellValue) === String(excluded);
}

/**
 * Indica si la fila debe excluirse de la selección según `excludedRows`.
 */
export function isRowExcludedFromSelection<T>(
  row: RowConfig<T>,
  excludedRows?: ExcludedRowsConfig<T>
): boolean {
  if (!excludedRows?.rows?.length) return false;
  const key = excludedRows.excludeKey as keyof RowConfig<T>;
  const cellValue = row[key];
  return excludedRows.rows.some((v) => valuesMatch(cellValue, v));
}
